export const PaymentProcessors: Record<number, string> = {
  1: 'Stripe',
  2: 'TouchNet',
  3: 'CBORD',
  4: 'Transact',
  5: 'Atrium',
};

export enum PaymentProcessorIds {
  Stripe = 1,
  TouchNet = 2,
  CBORD = 3,
  Transact = 4,
  Atrium = 5,
}
